import {Decoder, equal, oneOf} from 'json-bouncer'

export type M = 'Canceled' | 'Waiting' | 'Ready' | 'Shipped'

export function decoder(): Decoder<M> {
    return oneOf([
        equal<M>('Canceled'),
        equal<M>('Waiting'),
        equal<M>('Ready'),
        equal<M>('Shipped'),
    ])
}

export function label(orderStatus: M): string {
    switch (orderStatus) {
        case 'Canceled':
            return 'Storniert'
        case 'Waiting':
            return 'Zahlung ausstehend'
        case 'Ready':
            return 'Bestellt'
        case 'Shipped':
            return 'Geliefert'
    }
}

export function all(): M[] {
    return [
        'Canceled',
        'Waiting',
        'Ready',
        'Shipped',
    ]
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderStatus.ts